import * as amplitude from '@amplitude/analytics-browser';

const API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;

let initialized = false;

export function initAnalytics() {
  if (initialized || !API_KEY) return;
  amplitude.init(API_KEY, {
    autocapture: { elementInteractions: false },
  });
  initialized = true;
}

export function identifyWallet(walletAddress: string) {
  if (!initialized) return;
  amplitude.setUserId(walletAddress.toLowerCase());
}

export function resetIdentity() {
  if (!initialized) return;
  amplitude.reset();
}

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  if (!initialized) return;
  amplitude.track(name, properties);
}

export function trackPageView(pageName: string, properties?: Record<string, unknown>) {
  if (!initialized) return;
  amplitude.track('Page View', { page: pageName, ...properties });
}

export const Events = {
  WALLET_CONNECTED: 'Wallet Connected',
  WALLET_DISCONNECTED: 'Wallet Disconnected',
  SIGN_IN: 'Sign In',
  SIGN_OUT: 'Sign Out',
  // Legacy aliases kept so any remaining call sites compile without changes
  SIWE_SIGN_IN: 'Sign In',
  SIWE_SIGN_OUT: 'Sign Out',
  PAGE_VIEW: 'Page View',
  SUBSCRIBE_PAGE_VIEWED: 'Subscribe Page Viewed',
  PLAN_SELECTED: 'Plan Selected',
  DURATION_SELECTED: 'Duration Selected',
  PROMO_CODE_APPLIED: 'Promo Code Applied',
  SUBSCRIPTION_STARTED: 'Subscription Started',
  PAYMENT_INITIATED: 'Payment Initiated',
  PAYMENT_SUBMITTED: 'Payment Submitted',
  AI_ADVISOR_QUERY: 'Origin AI Query',
  AI_VOICE_INPUT: 'AI Voice Input',
  AI_VOICE_PLAYBACK: 'AI Voice Playback',
  // Funnel instrumentation (TOB-157 / TOB-158)
  LIVE_BALANCE_VIEWED: 'Live Balance Viewed',
  PAYWALL_VIEWED: 'Paywall Viewed',
  PAYWALL_CTA_CLICKED: 'Paywall CTA Clicked',
  SUBSCRIPTION_COMPLETED: 'Subscription Completed',
  CALCULATOR_USED: 'Calculator Used',
  SPIDER_WEB_VIEWED: 'Spider Web Viewed',
  YIELD_DASHBOARD_VIEWED: 'Yield Dashboard Viewed',
  FEATURE_USED: 'Feature Used',
  REWARDS_HUB_VIEWED: 'Rewards Hub Viewed',
  ACHIEVEMENT_UNLOCKED: 'Achievement Unlocked',
  RANK_PROGRESSION: 'Rank Progression',
  ADMIN_ACTION: 'Admin Action',
  SUPER_ADMIN_ACTION: 'Super Admin Action',
  ONBOARDING_STARTED: 'Onboarding Started',
  ONBOARDING_STEP_COMPLETED: 'Onboarding Step Completed',
  ONBOARDING_COMPLETED: 'Onboarding Completed',
  ONBOARDING_SKIPPED: 'Onboarding Skipped',
} as const;
